import QRCodeStyling from 'qr-code-styling';

function useQrCode() {
  /**
   * Create a QR code as an SVG data URL.
   * @param value The data to encode in the QR code.
   * @param logo The image to overlay on the QR code.
   * @returns The SVG data URL of the QR code.
   * @throws Error if the QR code could not be created.
   */
  const createQrCodeAsSVGDataURL = async (value: string, logo?: string) => {
    const generator = new QRCodeStyling({
      data: value,
      width: 124,
      height: 124,
      type: 'svg',
      margin: 0,
      qrOptions: {
        typeNumber: 11,
        mode: 'Byte',
        errorCorrectionLevel: 'Q',
      },
      image: logo,
      imageOptions: { hideBackgroundDots: true, imageSize: 0.4, margin: 0 },
    });
    const blob = await generator.getRawData('svg');
    return new Promise<string>((resolve, reject) => {
      const a = new FileReader();
      a.readAsDataURL(blob!);
      a.onload = function () {
        resolve(a.result as string);
      };
      a.onerror = function () {
        reject(a.error);
      };
    });
  };

  const imageTodataURL = (image: HTMLImageElement) => {
    const canvas = document.createElement('canvas');
    canvas.width = image.width;
    canvas.height = image.height;
    const ctx = canvas.getContext('2d');
    if (!ctx) {
      throw new Error('Could not get 2d context');
    }
    ctx.drawImage(image, 0, 0);
    return canvas.toDataURL('image/png');
  };

  const svgToDataURL = (svg: string) => {
    const blob = new Blob([svg], { type: 'image/svg+xml' });
    return new Promise<string>((resolve, reject) => {
      const a = new FileReader();
      a.readAsDataURL(blob!);
      a.onload = function () {
        resolve(a.result as string);
      };
      a.onerror = function () {
        reject(a.error);
      };
    });
  };

  /**
   * Create a QR login link for the login page.
   * @param loginCard The login card to create the link for.
   * @returns The QR login link.
   */
  const createLoginLink = (appUrl: string, userUid: string, qrToken: string) =>
    `${appUrl}/login/qr?userUid=${userUid}&token=${qrToken}&redirect=/redirect`;

  return {
    svgToDataURL,
    imageTodataURL,
    createLoginLink,
    createQrCodeAsSVGDataURL,
  };
}

export default useQrCode;
